import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";

class CommentsService {

    async getAllComments(designProposalId) {
        return axios.get(ApiHelper.getAllCommentsUrl(designProposalId), {
            headers: authHelper.authHeader(),
        }).then(result => {
            return Promise.resolve(result.data);
        }).catch(errorResponse => {
            return Promise.reject(errorResponse);
        });
    }

    async saveComment(designProposalId, text) {
        return axios.post(ApiHelper.getSaveCommentUrl(designProposalId), {
            text: text,
        }, {
            headers: authHelper.authHeader(),
        }).then(result => {
            return Promise.resolve(result);
        }).catch(errorResponse => {
            console.log('error')
            return Promise.reject(errorResponse);
        });
    }

    async saveSubcomment(designProposalId,subCommentId,text) {
        return axios.post(ApiHelper.getSaveSubcommentUrl(designProposalId,subCommentId),{
            text: text
        }, {
            headers: authHelper.authHeader(),
        }).then(result => {
            return Promise.resolve(result);
        }).catch(errorResponse => {
            return Promise.reject(errorResponse);
        });
    }

}

export default CommentsService;